import clsx from "clsx";
import React from "react";
import styles from "./styles.module.css";
import ImageComponent from "../../ImageComponent";
import { getHeight, getWidth } from "../../../utils/relativeSizes";
import blueToken from "../../../assets/blue-token-icon.svg";
import redToken from "../../../assets/red-token-icon.svg";
import greeToken from "../../../assets/green-token-icon.svg";
import { useSelector } from "react-redux";
import { getIsScoreRevealAnimationVisible } from "../../../store/selectors/ludoboardSelectors";
import { useTranslation } from "react-i18next";

const KukariScoreNudge = () => {
  const { t } = useTranslation();
  const tokenWrapper = [
    {
      iconSrc: redToken,
      alt: "red-token"
    },
    {
      iconSrc: greeToken,
      alt: "green-token"
    },
    {
      iconSrc: blueToken,
      alt: "blue-token"
    },
  ]

  const isScoreRevealAnimationVisible = useSelector(getIsScoreRevealAnimationVisible);

  if (!isScoreRevealAnimationVisible) {
    return null
  }

  return(
    <>
      <div className={clsx(styles.nudgeContainer, "absolute flex alignItemCenter")}
        style={{
          height: getHeight(46),
          width: getWidth(334),
          bottom: getHeight(120),
          gap: getWidth(15),
        }}
      >
        <div className={clsx(styles.tokenWrapper, "flex alignItemCenter justifyContentCenter")}>
          {tokenWrapper.map(({iconSrc, alt}, index)=>(
            <div key={index}>
              <ImageComponent
                src={iconSrc}
                alt={alt}
                style={{
                  height: getHeight(32),
                  width: getHeight(19),
                }}
              />
            </div>
          ))}
        </div>
        <div className={clsx(styles.pipe)} />
        <div className={clsx(styles.message, "fontSizeSm12 fontWeight700 textAlignLeft fontColorLightBlue")}>{t("tapOnRedBlueOrGreenTokensToCheckTheirPoints")}</div>
      </div>
    </>
  )
}
export default KukariScoreNudge;